import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDrag = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		stroke: "none",
		strokeWidth: 1,
		fill: "var(--main-color)",
		fillRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsx("circle", {
				cx: 15,
				cy: 19,
				r: 2
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 15,
				cy: 12,
				r: 2
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 15,
				cy: 5,
				r: 2
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 9,
				cy: 19,
				r: 2
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 9,
				cy: 12,
				r: 2
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 9,
				cy: 5,
				r: 2
			})
		]
	})
});
export { SvgDrag as ReactComponent };
